import { ExtractedLink } from "../gmail/types";

export default function LinkTable({ links }: { links: ExtractedLink[] }) {
  if (!links.length) return <p>No links found in this message.</p>;
  return (
    <div className="table-wrapper">
      <table className="table">
        <thead>
          <tr>
            <th>Domain</th>
            <th>URL</th>
            <th>Flags</th>
          </tr>
        </thead>
        <tbody>
          {links.map((link) => (
            <tr key={link.href}>
              <td>{link.domain ?? ""}</td>
              <td>
                <a href={link.href} target="_blank" rel="noreferrer noopener">
                  {link.href}
                </a>
              </td>
              <td>{link.flags.join(", ") || "None"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
